// extracted by mini-css-extract-plugin
export default {"btn":"style_btn__xS5MD","select":"style_select__8EHWy"};